import React from "react";
import { Card } from "react-bootstrap";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";
export default function Faq() {
    const [activeKey, setActiveKey] = useState("0");
    const handleToggle = (key) => {
        setActiveKey(activeKey === key ? null : key);
    };
    return (
        <>
            <section className="faq-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="faqlink-area">
                                <ul>
                                    <li> <Link to={"/"}>Home</Link> </li>
                                    <li>|</li>
                                    <li>FAQs</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="faqasked-area">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-5 col-lg-3 privacy-left">
                            <div className="faq-quickbox">
                                <span className="faqquickbox-text heading">Quick Links</span>
                                <ul>
                                    <li>
                                        <NavLink to="/terms-condition" className={({ isActive }) => isActive ? "active" : ""}>Term & Conditions</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/privacy-policy" className={({ isActive }) => isActive ? "active" : ""}>Privacy Policy</NavLink>
                                    </li>
                                    <li><NavLink to="/faq" className={({ isActive }) => isActive ? "active" : ""}> FAQs</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-sm-12 col-md-7 col-lg-9">
                            <div className="faqaccordion-area">
                                <h1 className="heading">Frequently Asked Question</h1>
                                <Accordion activeKey={activeKey} className="general-faq">
                                    <Card className={activeKey === "0" ? "active" : ""}>
                                        <Card.Header>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header className="accor-btn-box" as="span" onClick={() => handleToggle("0")}>
                                                    <label className="accor-text-head heading">01. Which industries and sectors does Supershine serve?</label>
                                                    <span>{activeKey === "0" ? "−" : "+"}</span>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <p>Supershine specializes in commercial laundry solutions across hospitality (hotels, resorts), healthcare (hospitals, clinics), education (schools, universities, hostels), defence (military bases, naval installations), railways (coach laundries, depot facilities), industrial operations, laundromats, and facility management companies requiring high-volume, reliable textile processing systems.</p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Card.Header>
                                    </Card>

                                    <Card className={activeKey === "1" ? "active" : ""}>
                                        <Card.Header>
                                            <Accordion.Item eventKey="1">
                                                <Accordion.Header className="accor-btn-box" as="span" onClick={() => handleToggle("1")}>
                                                    <label className="accor-text-head heading">02. What purchasing and investment models do you offer?</label>
                                                    <span>{activeKey === "1" ? "−" : "+"}</span>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <p> We provide flexible procurement options including outright purchase (CAPEX model), operational lease agreements (OPEX model), equipment financing partnerships, and build-operate-transfer arrangements. Our sales team structures solutions matching your budget constraints, cash flow preferences, and accounting requirements for optimal financial fit.</p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Card.Header>
                                    </Card>

                                    <Card className={activeKey === "2" ? "active" : ""}>
                                        <Card.Header>
                                            <Accordion.Item eventKey="2">
                                                <Accordion.Header className="accor-btn-box" as="span" onClick={() => handleToggle("2")}>
                                                    <label className="accor-text-head heading">03. Is installation and commissioning included with equipment?</label>
                                                    <span>{activeKey === "2" ? "−" : "+"}</span>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <p>Yes. Every Supershine system includes professional installation, utility connections, equipment commissioning, performance validation, and operational testing. Our technical teams handle complete setup from delivery through final handover, ensuring systems meet specified performance standards before you begin operations.</p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Card.Header>
                                    </Card>

                                    <Card className={activeKey === "3" ? "active" : ""}>
                                        <Card.Header>
                                            <Accordion.Item eventKey="3">
                                                <Accordion.Header className="accor-btn-box" as="span" onClick={() => handleToggle("3")}>
                                                    <label className="accor-text-head heading">04.  What after-sales support and maintenance do you provide?</label>
                                                    <span>{activeKey === "3" ? "−" : "+"}</span>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <p>We offer comprehensive support including 24/7 technical helpline, preventive maintenance contracts, rapid spare parts availability, on-site repair services, remote diagnostics, performance optimization visits, and emergency breakdown response. Service agreements are customizable based on your operational criticality and budget parameters.</p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Card.Header>
                                    </Card>

                                    <Card className={activeKey === "4" ? "active" : ""}>
                                        <Card.Header>
                                            <Accordion.Item eventKey="4">
                                                <Accordion.Header className="accor-btn-box" as="span" onClick={() => handleToggle("4")}>
                                                    <label className="accor-text-head heading">05. Can you customize equipment for specific operational requirements?</label>
                                                    <span>{activeKey === "4" ? "−" : "+"}</span>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <p>Absolutely. We engineer custom solutions for unique space constraints, special textile requirements, specific capacity needs, utility limitations, regulatory compliance demands, and operational workflows. Our technical team assesses your requirements and configures systems matching your exact operational specifications.</p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Card.Header>
                                    </Card>

                                    <Card className={activeKey === "5" ? "active" : ""}>
                                        <Card.Header>
                                            <Accordion.Item eventKey="5">
                                                <Accordion.Header className="accor-btn-box" as="span" onClick={() => handleToggle("5")}>
                                                    <label className="accor-text-head heading">06. How energy and water efficient are Supershine systems?</label>
                                                    <span>{activeKey === "5" ? "−" : "+"}</span>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <p>Our equipment delivers 30-40% reduction in water consumption and 25-35% lower energy usage versus older systems through advanced heating technology, water recycling capabilities, optimized extraction, and intelligent cycle programming. This translates to substantial monthly utility savings and faster ROI on equipment investment.</p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Card.Header>
                                    </Card>

                                    <Card className={activeKey === "6" ? "active" : ""}>
                                        <Card.Header>
                                            <Accordion.Item eventKey="6">
                                                <Accordion.Header className="accor-btn-box" as="span" onClick={() => handleToggle("6")}>
                                                    <label className="accor-text-head heading">07.  Do you provide operator training and technical documentation?</label>
                                                    <span>{activeKey === "6" ? "−" : "+"}</span>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <p>Yes. Every installation includes comprehensive operator training covering equipment operation, safety protocols, maintenance procedures, troubleshooting basics, and quality control. We provide training manuals, operational guides, safety documentation, and ongoing support to ensure your staff operates systems confidently and effectively.</p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Card.Header>
                                    </Card>

                                    <Card className={activeKey === "7" ? "active" : ""}>
                                        <Card.Header>
                                            <Accordion.Item eventKey="7">
                                                <Accordion.Header className="accor-btn-box" as="span" onClick={() => handleToggle("7")}>
                                                    <label className="accor-text-head heading">08. How do I request a quotation or schedule a consultation?</label>
                                                    <span>{activeKey === "7" ? "−" : "+"}</span>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <p>Contact our sales team through the website inquiry form, phone, or email with your project details including laundry volume, facility type, space availability, and timeline. We'll schedule a consultation, assess your requirements, and provide detailed proposals with equipment recommendations, pricing, installation timelines, and ROI projections.</p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Card.Header>
                                    </Card>
                                </Accordion>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}
